import { Directive, HostListener, Self, ElementRef, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

const CSS_CLASS_NAME = 'status-danger';

@Directive({
    selector: '[bfValidationStatus]',
})
export class ValidationStatusDirective {

    constructor(
        @Self() private control: NgControl,
        private element: ElementRef,
        private renderer: Renderer2 ) { }

    @HostListener('blur')
    onBlur() {
        this.checkStatus();
    }

    private checkStatus() {
        if (this.control.invalid) this.markAsInvalid();
        else this.markAsValid();
    }

    private markAsInvalid() {
        this.renderer.addClass(this.element.nativeElement, CSS_CLASS_NAME);
    }

    private markAsValid() {
        this.renderer.removeClass(this.element.nativeElement, CSS_CLASS_NAME);
    }
}
